import "./Reviews.scss"

export default function Review({text, name, course}){

    return(
        <div className="Review">
            <div className="review-container">
                <div className="review-header">
                    <div className="name">
                     {name}
                    </div>
                    {/* <div className="date">
                        {date}
                    </div> */}
                </div>
                <h3 className="course">
                    {course}
                </h3>
                <div className="text">
                   " {text} "
                </div>
                
            </div>
        </div>
    )
}